/**
 * @flow
 * @relayHash 53ada4652ea6b49a443798da6fe62e88
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type TopicEditor_topic$ref = any;
export type queries_topicQuery_QueryVariables = {|
  id: string
|};
export type queries_topicQuery_QueryResponse = {|
  +topic: ?{|
    +$fragmentRefs: TopicEditor_topic$ref
  |}
|};
export type queries_topicQuery_Query = {|
  variables: queries_topicQuery_QueryVariables,
  response: queries_topicQuery_QueryResponse,
|};
*/


/*
query queries_topicQuery_Query(
  $id: ID!
) {
  topic: node(id: $id) {
    __typename
    ...TopicEditor_topic
    id
  }
}

fragment TopicEditor_topic on Topic {
  id
  name
  slug
  hidden
  seoTitle
  seoDescription
  seoKeywords
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id",
    "type": "ID!"
  }
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "queries_topicQuery_Query",
  "id": null,
  "text": "query queries_topicQuery_Query(\n  $id: ID!\n) {\n  topic: node(id: $id) {\n    __typename\n    ...TopicEditor_topic\n    id\n  }\n}\n\nfragment TopicEditor_topic on Topic {\n  id\n  name\n  slug\n  hidden\n  seoTitle\n  seoDescription\n  seoKeywords\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "queries_topicQuery_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": "topic",
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "TopicEditor_topic",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "queries_topicQuery_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": "topic",
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "__typename",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "type": "Topic",
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "slug",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "hidden",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "seoTitle",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "seoDescription",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "seoKeywords",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '7dec8d41d8cf34a5cd667b678509c43a';
module.exports = node;



// WEBPACK FOOTER //
// src/__generated__/queries_topicQuery_Query.graphql.js